import metaContent from '../fn/metaContent';

const csrfToken = () => metaContent('csrf-token');

export default csrfToken;
